module.exports = __webpack_public_path__ + "img/logo.ff599e0e.png";